
import { NavItem, Property, Agent, Community } from './types';

export const DEFAULT_LOGO = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 250'%3E%3Cdefs%3E%3ClinearGradient id='gold-grad' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' stop-color='%23F9E076'/%3E%3Cstop offset='50%25' stop-color='%23D4AF37'/%3E%3Cstop offset='100%25' stop-color='%23B08D22'/%3E%3C/linearGradient%3E%3ClinearGradient id='silver-grad' x1='100%25' y1='0%25' x2='0%25' y2='100%25'%3E%3Cstop offset='0%25' stop-color='%23FFFFFF'/%3E%3Cstop offset='50%25' stop-color='%23C0C0C0'/%3E%3Cstop offset='100%25' stop-color='%23808080'/%3E%3C/linearGradient%3E%3Cfilter id='dropShadow'%3E%3CfeGaussianBlur in='SourceAlpha' stdDeviation='3'/%3E%3CfeOffset dx='1' dy='1' result='offsetblur'/%3E%3CfeComponentTransfer%3E%3CfeFuncA type='linear' slope='0.3'/%3E%3C/feComponentTransfer%3E%3CfeMerge%3E%3CfeMergeNode/%3E%3CfeMergeNode in='SourceGraphic'/%3E%3C/feMerge%3E%3C/filter%3E%3C/defs%3E%3Cg filter='url(%23dropShadow)'%3E%3Cpath d='M100,20 C140,20 160,60 140,90 C120,120 80,120 60,90 C40,60 60,20 100,20 Z' fill='url(%23silver-grad)' transform='translate(0, -10)' /%3E%3Cpath d='M60,90 C40,120 40,180 80,210 C90,218 100,220 110,215 C90,200 70,160 80,120 C85,100 100,80 120,70 C100,60 70,70 60,90 Z' fill='url(%23silver-grad)' /%3E%3Cpath d='M130,110 C150,110 165,130 165,150 C165,170 150,190 130,190 C110,190 95,170 95,150 C95,130 110,110 130,110 Z' fill='url(%23gold-grad)' /%3E%3Cpath d='M130,190 C110,190 80,230 100,240 C120,250 160,230 180,180 C190,140 170,100 150,90 C160,110 160,160 130,190 Z' fill='url(%23gold-grad)' /%3E%3C/g%3E%3C/svg%3E";

export const COMMUNITY_STRUCTURE = [
  {
    label: 'DOWNTOWN & BUSINESS BAY',
    subItems: [
      { label: 'Downtown Dubai', path: '/buy?search=Downtown%20Dubai' },
      { label: 'Business Bay', path: '/buy?search=Business%20Bay' },
      { label: 'Old Town', path: '/buy?search=Old%20Town' },
      { label: 'DIFC', path: '/buy?search=DIFC' },
      { label: 'Burj Khalifa', path: '/buy?search=Burj%20Khalifa' }
    ]
  },
  {
    label: 'MARINA, JBR & BLUEWATERS',
    subItems: [
      { label: 'Dubai Marina', path: '/buy?search=Dubai%20Marina' },
      { label: 'JBR', path: '/buy?search=JBR' },
      { label: 'Bluewaters Island', path: '/buy?search=Bluewaters' },
      { label: 'Dubai Harbour', path: '/buy?search=Dubai%20Harbour' },
      { label: 'Emaar Beachfront', path: '/buy?search=Emaar%20Beachfront' },
    ]
  },
  {
    label: 'PALM JUMEIRAH & ARCHIPELAGOS',
    subItems: [
      { label: 'Palm Jumeirah', path: '/buy?search=Palm%20Jumeirah' },
      { label: 'Palm Jebel Ali', path: '/buy?search=Palm%20Jebel%20Ali' },
      { label: 'The World Islands', path: '/buy?search=The%20World%20Islands' },
      { label: 'Dubai Maritime City', path: '/buy?search=Maritime%20City' }
    ]
  },
  {
    label: 'EMIRATES LIVING & HILLS',
    subItems: [
      { label: 'Dubai Hills Estate', path: '/buy?search=Dubai%20Hills' },
      { label: 'Emirates Hills', path: '/buy?search=Emirates%20Hills' },
      { label: 'The Meadows', path: '/buy?search=The%20Meadows' },
      { label: 'The Lakes', path: '/buy?search=The%20Lakes' },
      { label: 'The Springs', path: '/buy?search=The%20Springs' },
      { label: 'Jumeirah Golf Estates', path: '/buy?search=Golf%20Estates' }
    ]
  },
  {
    label: 'JUMEIRAH VILLAGE & TRIANGLE',
    subItems: [
      { label: 'JVC (Jumeirah Village Circle)', path: '/buy?search=JVC' },
      { label: 'JVT (Jumeirah Village Triangle)', path: '/buy?search=JVT' },
      { label: 'Arjan', path: '/buy?search=Arjan' },
      { label: 'Dubai Sports City', path: '/buy?search=Sports%20City' },
      { label: 'Motor City', path: '/buy?search=Motor%20City' },
      { label: 'Dubai Production City (IMPZ)', path: '/buy?search=IMPZ' }
    ]
  },
  {
    label: 'DUBAI CREEK & MEYDAN',
    subItems: [
      { label: 'Dubai Creek Harbour', path: '/buy?search=Creek%20Harbour' },
      { label: 'Meydan', path: '/buy?search=Meydan' },
      { label: 'Sobha Hartland', path: '/buy?search=Sobha' },
      { label: 'MBR City', path: '/buy?search=MBR%20City' },
      { label: 'Al Jaddaf', path: '/buy?search=Al%20Jaddaf' }
    ]
  },
  {
    label: 'VILLA COMMUNITIES',
    subItems: [
      { label: 'Arabian Ranches 1', path: '/buy?search=Arabian%20Ranches%201' },
      { label: 'Arabian Ranches 2', path: '/buy?search=Arabian%20Ranches%202' },
      { label: 'Arabian Ranches 3', path: '/buy?search=Arabian%20Ranches%203' },
      { label: 'Damac Hills', path: '/buy?search=Damac%20Hills' },
      { label: 'Damac Hills 2', path: '/buy?search=Damac%20Hills%202' },
      { label: 'Tilal Al Ghaf', path: '/buy?search=Tilal%20Al%20Ghaf' },
      { label: 'Mudon', path: '/buy?search=Mudon' },
      { label: 'Villanova', path: '/buy?search=Villanova' },
      { label: 'Town Square', path: '/buy?search=Town%20Square' },
      { label: 'The Villa', path: '/buy?search=The%20Villa' }
    ]
  },
  {
    label: 'AL BARSHA & JLT',
    subItems: [
      { label: 'JLT (Jumeirah Lake Towers)', path: '/buy?search=JLT' },
      { label: 'Al Barsha 1', path: '/buy?search=Al%20Barsha%201' },
      { label: 'Al Barsha South', path: '/buy?search=Al%20Barsha%20South' },
      { label: 'Dubai Internet City', path: '/buy?search=Internet%20City' }
    ]
  },
  {
    label: 'DUBAI SOUTH & EXPO',
    subItems: [
      { label: 'Dubai South', path: '/buy?search=Dubai%20South' },
      { label: 'Expo City Dubai', path: '/buy?search=Expo%20City' },
      { label: 'Emaar South', path: '/buy?search=Emaar%20South' }
    ]
  },
  {
    label: 'ABU DHABI',
    subItems: [
      { label: 'Yas Island', path: '/buy?search=Yas%20Island' },
      { label: 'Saadiyat Island', path: '/buy?search=Saadiyat' },
      { label: 'Al Reem Island', path: '/buy?search=Al%20Reem' },
      { label: 'Al Raha Beach', path: '/buy?search=Al%20Raha' },
      { label: 'Khalifa City', path: '/buy?search=Khalifa' },
      { label: 'Al Maryah Island', path: '/buy?search=Al%20Maryah' }
    ]
  },
  {
    label: 'SHARJAH & NORTHERN EMIRATES',
    subItems: [
      { label: 'Aljada (Sharjah)', path: '/buy?search=Aljada' },
      { label: 'Masaar (Sharjah)', path: '/buy?search=Masaar' },
      { label: 'Al Majaz (Sharjah)', path: '/buy?search=Al%20Majaz' },
      { label: 'Al Marjan Island (RAK)', path: '/buy?search=Marjan%20Island' },
      { label: 'Mina Al Arab (RAK)', path: '/buy?search=Mina%20Al%20Arab' },
      { label: 'Ajman Corniche', path: '/buy?search=Ajman' }
    ]
  }
];

export const INITIAL_COMMUNITIES: Community[] = [
  {
    id: 'comm-1',
    title: 'Downtown Dubai',
    description: 'The center of now. Home to Burj Khalifa and Dubai Mall.',
    imageUrl: 'https://images.unsplash.com/photo-1597659840241-37e2b9c2f55f?q=80&w=1000'
  },
  {
    id: 'comm-2',
    title: 'Dubai Marina',
    description: 'Luxury waterfront living with high-rise apartments and vibrant nightlife.',
    imageUrl: 'https://images.unsplash.com/photo-1580674684081-7617fbf3d745?q=80&w=1000'
  },
  {
    id: 'comm-3',
    title: 'Palm Jumeirah',
    description: 'Iconic man-made island offering world-class luxury villas and resorts.',
    imageUrl: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?q=80&w=1000'
  }
];

export const NAV_ITEMS: NavItem[] = [
  { label: 'Home', path: '/' },
  { 
    label: 'Buy', 
    path: '/buy',
    subItems: [
      { label: 'Properties for Sale', path: '/buy' },
      { label: 'Buying Guide', path: '/buying-guide' },
      { label: 'Mortgage Calculator', path: '/mortgage-calculator' },
    ]
  },
  { 
    label: 'Rent', 
    path: '/rent',
    subItems: [
      { label: 'Properties for Rent', path: '/rent' },
    ]
  },
  { label: 'Off-Plan', path: '/off-plan' },
  { label: 'Communities', path: '/communities' },
  { label: 'UK Investment', path: '/uk-investment' },
  { label: 'Careers', path: '/careers' },
  { label: 'Portal', path: '/admin' },
];

export const INITIAL_AGENTS: Agent[] = [
  {
    id: 'master-admin',
    name: 'Guardian Admin',
    email: 'hello@guardianhousing.ae',
    phone: '+971 50 580 4669',
    whatsapp: '971505804669',
    photoUrl: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=200',
    role: 'admin',
    password: 'guardian2024'
  },
  {
    id: 'arslan-admin',
    name: 'Arslan Admin',
    email: 'arslan@guardianhousing.ae',
    phone: '+971 50 580 4669',
    whatsapp: '971505804669',
    photoUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=200',
    role: 'admin',
    password: 'guardian2024'
  }
];

export const INITIAL_PROPERTIES: Property[] = [
  {
    id: 'prop-sale-1',
    title: 'Ultra-Luxury Penthouse with Marina Views',
    price: 8500000,
    currency: 'AED',
    location: 'Dubai Marina',
    lat: 25.077,
    lng: 55.131,
    type: 'sale',
    propertyType: 'Penthouse',
    status: 'Active',
    beds: 4,
    bedType: '4 BHK',
    baths: 5,
    bathType: '5 BATH',
    sqft: 4500,
    imageUrl: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1000',
    images: [
        'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1000',
        'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?q=80&w=1000',
        'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=1000'
    ],
    description: 'Breathtaking panoramic views of the Dubai Marina skyline and Arabian Gulf. Features floor-to-ceiling windows, private elevator, and Italian marble finishes.',
    agentId: 'master-admin',
    isFeatured: true
  }
];

export const PARTNERS = ['EMAAR', 'DAMAC', 'SOBHA', 'TIGER GROUP', 'DANUBE PROPERTIES', 'BINGHATTI'];
export const CONTACT_INFO = { phone: '+971 50 580 4669', email: 'hello@guardianhousing.ae', address: 'Dubai, UAE' };
